<template>
  <div class="border-b border-gray-900/10 pb-12 mt-8">
    <FormSelectField
      :modelValue="characteristics"
      @update:modelValue="emit('update:characteristics', $event)"
      field-path="attributes.unusualClientCharacteristics"
      :field-label="$gettext('Le client présente-t-il des caractéristiques inhabituelles pour l\'agent immobilier ?')"
      :field-attrs="characteristicsAttrs"
      :errors="errors"
      :options="yesNoOptions" />
    <div v-if="characteristics === 'yes'" class="mt-4 space-y-2">
      <label
        v-for="reason in reasonOptions"
        :key="reason.value"
        class="group flex items-start gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 cursor-pointer transition-colors hover:border-indigo-300 hover:bg-indigo-50/40 has-[input:checked]:border-indigo-500 has-[input:checked]:bg-indigo-50 has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-indigo-500"
      >
        <input
          type="checkbox"
          :value="reason.value"
          :checked="(reasons || []).includes(reason.value)"
          @change="toggleReason(reason.value)"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
        <span class="text-sm text-gray-900 group-has-[input:checked]:text-indigo-900 group-has-[input:checked]:font-medium leading-snug">{{ reason.label }}</span>
      </label>
      <p v-if="errors['attributes.unusualClientReasons']" class="text-sm text-red-600">{{ errors['attributes.unusualClientReasons'] }}</p>
    </div>
    <div v-if="characteristics === 'yes'" class="mt-4">
      <FormTextareaField
        :modelValue="explanation"
        @update:modelValue="emit('update:explanation', $event)"
        field-path="attributes.unusualClientExplanation"
        :field-label="$gettext('Explications (optionnel)')"
        :field-attrs="explanationAttrs"
        :errors="errors" />
    </div>
  </div>
</template>

<script setup>
import { watch } from "vue";
import { useGettext } from "vue3-gettext";
import FormSelectField from "@/components/form-fields/FormSelectField.vue";
import FormTextareaField from "@/components/form-fields/FormTextareaField.vue";

const { $gettext } = useGettext();

const props = defineProps({
  characteristics: { type: String, default: null },
  reasons: { type: Array, default: () => [] },
  explanation: { type: String, default: null },
  characteristicsAttrs: { type: Object, default: () => ({}) },
  explanationAttrs: { type: Object, default: () => ({}) },
  errors: { type: Object, default: () => ({}) }
});

const emit = defineEmits([
  "update:characteristics",
  "update:reasons",
  "update:explanation"
]);

const yesNoOptions = [
  { value: "yes", label: $gettext("Oui") },
  { value: "no", label: $gettext("Non") }
];

const reasonOptions = [
  { value: "refusal_basic_info", label: $gettext("Le client refuse de fournir des informations de base sur son identité ou l'origine des fonds") },
  { value: "complex_payment", label: $gettext("Le client propose un paiement complexe ou inhabituel (multiples comptes, pays différents, tiers payeurs)") },
  { value: "new_company_no_activity", label: $gettext("Une société récemment créée achète un bien de grande valeur sans activité économique cohérente") },
  { value: "unclear_ubo", label: $gettext("Le bénéficiaire effectif réel reste difficile à identifier") },
  { value: "complex_legal_structure", label: $gettext("L'opération implique des montages juridiques inutilement complexes pour une transaction simple") },
  { value: "other", label: $gettext("Autre") }
];

const toggleReason = (value) => {
  const current = Array.isArray(props.reasons) ? [...props.reasons] : [];
  const idx = current.indexOf(value);
  if (idx >= 0) {
    current.splice(idx, 1);
  } else {
    current.push(value);
  }
  emit("update:reasons", current);
};

watch(() => props.characteristics, (newVal) => {
  if (newVal !== "yes") {
    emit("update:reasons", []);
    emit("update:explanation", null);
  }
});
</script>
